import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiUsers, FiUser, FiRefreshCw } = FiIcons;

const useCases = [
  {
    icon: FiUsers,
    title: 'The Family Plan Trapped by Fees',
    problem:
      'You want to move your family of four to a $15/mo Mint Mobile plan, but Verizon is demanding $1,200 to pay off your locked devices.',
    solution:
      'Compare micro-loan options to cover the $1,200 buyout today, and start saving hundreds every month on your new network.',
  },
  {
    icon: FiUser,
    title: 'The Individual Upgrader',
    problem:
      'You owe $400 on your current iPhone with AT&T and want to switch to a cheaper MVNO, but you don\'t have the cash upfront to clear the debt.',
    solution:
      'Secure a quick $400 bridge loan to pay off AT&T, unlock your phone, and port your number to a $15/mo plan immediately.',
  },
  {
    icon: FiRefreshCw,
    title: 'The Trade-In Switcher',
    problem:
      'You want to jump to a cheaper carrier, but you\'re stuck in a 36-month bill credit trap with your current provider.',
    solution:
      'Trade in your locked device for instant cash value to help settle your carrier debt, freeing you up to switch networks stress-free.',
  },
];

export default function Testimonials() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <h2 className="text-3xl font-extrabold text-slate-900">
          Who is SwitchFree built for?
        </h2>
        <p className="mt-4 text-lg text-slate-500">
          Stop letting early termination fees dictate your network.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {useCases.map((item, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: idx * 0.1, duration: 0.5 }}
            className="bg-white rounded-2xl p-8 shadow-sm border border-slate-100 hover:shadow-md transition-shadow flex flex-col"
          >
            {/* Icon */}
            <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center mb-6 shrink-0">
              <SafeIcon icon={item.icon} className="w-6 h-6 text-blue-600" />
            </div>

            {/* Title */}
            <h3 className="text-lg font-bold text-slate-900 mb-5">
              {item.title}
            </h3>

            {/* Problem */}
            <div className="mb-4">
              <span className="text-xs font-bold uppercase tracking-widest text-slate-400">
                The Problem
              </span>
              <p className="mt-2 text-slate-600 text-sm leading-relaxed">
                {item.problem}
              </p>
            </div>

            {/* Divider */}
            <div className="border-t border-slate-100 my-4" />

            {/* Solution */}
            <div className="mt-auto">
              <span className="text-xs font-bold uppercase tracking-widest text-blue-600">
                The SwitchFree Solution
              </span>
              <p className="mt-2 text-slate-700 text-sm leading-relaxed font-medium">
                {item.solution}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}